import { SentimentName, SentimentType } from 'v2/core/entities/fields';

export function toSentimentName(sentimentType: SentimentType) {
  switch (sentimentType) {
    case SentimentType.Negative:
      return SentimentName.NEGATIVE;
    case SentimentType.Positive:
      return SentimentName.POSITIVE;
    case SentimentType.Neutral:
      return SentimentName.NEUTRAL;
    default:
      return sentimentType;
  }
}
